import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../context/AppContext";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LanguageAndNotificacions from "../components/LanguageAndNotificacions";

export default function Statistics() {
  const { t } = useTranslation();
  const { loading, updateLoading, showTanks, saveTanks, sharetanks, showDirects } = useContext(AppContext);
  const [searchEmail, setSearchEmail] = useState("");
  const [networks, setNetworks] = useState([]);
  const [dateFilter, setDateFilter] = useState();
  const [showDatePicker, setShowDatePicker] = useState(false); // Controla la visibilidad del selector de fecha
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(150);
  const [total, setTotal] = useState(0);
  const [pasivo, setPasivo] = useState([])
  const [range, setRange] = useState([])
  const [binary, setBinary] = useState([])
  const [residual, setResidual] = useState([])
  const [copy, setCopy] = useState([])
  const [userData, setUserData] = useState([]);
  const [totalBinario, setTotalBinario] = useState(0);
  const [totalRango, setTotalRango] = useState(0);
  const [totalResidual, setTotalResidual] = useState(0);
  const [totalArbitrage, setTotalArbitrage] = useState(0);
  const [tabActive, setTabActive] = useState("unilevel");
  const [fromDate, setFromDate] = useState("");
  const [untilDate, setUntilDate] = useState("");

  useEffect(() => {
    getNetworks();
    getStastics();
    myUser();
  }, []);

  const getNetworks = (date) => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/users-networks?date=${date}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {

        // Valores por defecto de los niveles
        const levelsDefault = [
          { level: 1, percentage: '7%', status: 0 },
          { level: 2, percentage: '3%', status: 0 },
          { level: 3, percentage: '2%', status: 0 },
          { level: 4, percentage: '2%', status: 0 },
          { level: 5, percentage: '1%', status: 0 },
          { level: 6, percentage: '1%', status: 0 },
          { level: 7, percentage: '1%', status: 0 },
          { level: 8, percentage: '3%', status: 0 },
        ];

        // Datos del response
        const networkData = response?.data || [];

        // Combina los niveles predeterminados con los del response
        const combinedLevels = levelsDefault.map((defaultLevel) => {
          const matchedLevel = networkData.find((item) => parseInt(item.level) === parseInt(defaultLevel.level));
          return matchedLevel ? { ...defaultLevel, ...matchedLevel } : defaultLevel;
        });

        // Actualiza el estado con los niveles combinados
        setNetworks(combinedLevels);
        setDateFilter(response?.date);
        updateLoading(false);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };


  const getStastics = (date) => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/notification-earnings?limit=50&page=0`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        let data = response.data;
        setPasivo(data?.arbitrage);
        setRange(data?.rango);
        setBinary(data?.binario);
        setResidual(data?.residualbinario);

        setFromDate(data?.start_date);
        setUntilDate(data?.end_date)
        // Sumar total_value por categoría
        const sumTotal = (arr) =>
          (arr || []).reduce((acc, curr) => acc + parseFloat(curr.total_value || 0), 0);
        const totalBinario = sumTotal(data?.binario);
        const totalRango = sumTotal(data?.rango);
        const totalResidual = sumTotal(data?.residualbinario);
        const totalArbitrage = sumTotal(data?.arbitrage);

        console.log("✅ Total Binario:", totalBinario);
        console.log("✅ Total Rango:", totalRango);
        console.log("✅ Total Residual:", totalResidual);
        console.log("✅ Total Arbitrage:", totalArbitrage);

        // Si quieres usarlos en la UI
        setTotalBinario(totalBinario);
        setTotalRango(totalRango);
        setTotalResidual(totalResidual);
        setTotalArbitrage(totalArbitrage);

        console.log(response)
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };


  const changeDate = (days) => {
    getNetworks(days);
    setShowDatePicker(false);
  };

  const changeDateByDays = (date, days) => {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    const year = result.getUTCFullYear();
    const month = String(result.getUTCMonth() + 1).padStart(2, '0');
    const day = String(result.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const formatNumber = (value) => {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    const valueString = value.toString();
    const [integerPart, decimalPart] = valueString.split('.');

    if (decimalPart && decimalPart.length > 3) {
      return `${integerPart}.${decimalPart.slice(0, 3)}`;
    }

    return valueString;
  };



  const myUser = () => {
    fetch(`${process.env.REACT_APP_BACKEND}/users`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        const data = response?.data;
        setUserData(data);
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };

  return (
    <>
      <div className="flex flex-col lg:flex-row lg:justify-between w-3/4 lg:w-full gap-3">
        <h1 className="text-white text-3xl">{t("_COPY._STATISTICS")}</h1>
        <LanguageAndNotificacions />
      </div>
      {/*** Search Users */}
      <div className="max-w-7xl mx-auto p-4 lg:p-6 h-full">
        <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full  my-2">
          <div className="flex flex-col gap-4 text-white my-4 justify-center">
            <div className="flex flex-col lg:flex-row items-center justify-around">
              <button className={`flex w-full lg:w-auto items-center p-2 text-white group ${tabActive === 'plan' ? ' background-ctx' : ''} border-2 border-zinc-800 hover:border-zinc-400 rounded-xl`} onClick={() => setTabActive('plan')} >{t("_DASHBOARD._TITLE6")}</button>
              <button className={`flex w-full lg:w-auto items-center p-2 text-white group ${tabActive === 'unilevel' ? ' background-ctx' : ''} border-2 border-zinc-800 hover:border-zinc-400 rounded-xl`} onClick={() => setTabActive('unilevel')} >{t("_DASHBOARD._TITLE7")}</button>
              <button className={`flex w-full lg:w-auto items-center p-2 text-white group ${tabActive === 'binario' ? ' background-ctx' : ''} border-2 border-zinc-800 hover:border-zinc-400 rounded-xl`} onClick={() => setTabActive('binario')} >{t("_DASHBOARD._TITLE8")}</button>
              <button className={`flex w-full lg:w-auto items-center p-2 text-white group ${tabActive === 'residual' ? ' background-ctx' : ''} border-2 border-zinc-800 hover:border-zinc-400 rounded-xl`} onClick={() => setTabActive('residual')} >{t("_DASHBOARD._TITLE9")}</button>
              <button className={`flex w-full lg:w-auto items-center p-2 text-white group ${tabActive === 'rango' ? ' background-ctx' : ''} border-2 border-zinc-800 hover:border-zinc-400 rounded-xl`} onClick={() => setTabActive('rango')} >{t("_DASHBOARD._TITLE5")}</button>
              <button className={`flex w-full lg:w-auto items-center p-2 text-white group ${tabActive === 'copy' ? ' background-ctx' : ''} border-2 border-zinc-800 hover:border-zinc-400 rounded-xl`} onClick={() => setTabActive('copy')} >{t("_DASHBOARD._TITLE10")}</button>
            </div>
          </div>
        </div>
        {tabActive !== "unilevel" && (
          <div className="bg-black/60 text-white lg:px-8 py-2 p-4 rounded-lg w-full border-zinc-600 border-2 my-2">
            <div className="flex lg:flex-row justify-between items-center">
              <div className="flex flex-col lg:flex-row  items-center gap-4 px-3 lg:h-12 h-auto rounded-lg text-white">
                <div>
                  <div className={`cursor-pointer inline-block px-4 py-2 rounded-lg border-2 text-white`} >
                    {t("_STATISTICS._FROM")}: {" "}   {fromDate}
                  </div>
                </div>
                <div>
                  <div className={`cursor-pointer inline-block px-4 py-2 rounded-lg border-2 text-white`} >
                    {t("_STATISTICS._UNTIL")}: {" "}   {untilDate}
                  </div>
                </div>
              </div>
              <div className="lg:block hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="px-3 h-12 rounded-lg text-white cursor-pointer"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        )}
        {tabActive === "unilevel" && (
          <div className="bg-black/60 text-white lg:px-8 py-2 p-4 rounded-lg w-full border-zinc-600 border-2 my-2">
            <div className="flex flex-col lg:flex-row justify-between items-center">
              <div>
                <div
                  className={`cursor-pointer inline-block px-4 py-2 rounded-lg border-2 text-white`}
                  onClick={() => getNetworks()}
                >
                  {t("_NETWORK._TODAY")}
                </div>
              </div>

              <div className="flex items-center justify-center px-3 h-12 rounded-lg text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6 cursor-pointer mx-2"
                  onClick={() => changeDate(changeDateByDays(dateFilter, -1))}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
                {dateFilter}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6 cursor-pointer mx-2"
                  onClick={() => changeDate(changeDateByDays(dateFilter, 1))}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
              </div>

              <div>
                {!showDatePicker ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="px-3 h-12 rounded-lg text-white cursor-pointer"
                    onClick={() => setShowDatePicker(true)} // Abrir el selector de fecha
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                    />
                  </svg>
                ) : (
                  <input type="date" className="border-2 rounded-lg bg-zinc-800 text-white px-4 py-2" onInput={(e) => {
                    if (e.target.value) {
                      changeDate(e.target.value); // Ejecutar solo cuando hay una fecha seleccionada
                    }
                  }} />
                )}
              </div>
            </div>
          </div>
        )}
        {/** Unilevel  3*/}
        {tabActive === "unilevel" && (
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full  ">
            <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                  <thead className="text-md text-white border-b-2">
                    <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                      <th className="px-6 py-4 ">
                        {t("_NETWORK._LEVEL")}

                      </th>
                      <th className="px-6 py-4">
                        {t("_NETWORK._USERS")}
                      </th>
                      <th className="px-6 py-4 ">
                        %
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_NETWORK._AMOUNT")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {networks.map((item, index) => (
                      <tr className={`border-b-2 ${parseInt(userData?.package_binary) >= item?.level ? "" : "bg-gray-500 opacity-40"}`} key={index}>
                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                          {item?.level}
                        </th>
                        <td className="px-6 py-4 text-white">
                          {item?.total_users ? item?.total_users : 0}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {item?.percentage}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {formatNumber(item?.total_amount || 0)} USD {parseInt(userData?.package_binary) >= item?.level ? "" : "Lost"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/** Pasivo 2*/}
        {tabActive === "plan" && (
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full">
            <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                  <thead className="text-md text-white border-b-2">
                    <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_D")}
                      </th>
                      <th className="px-6 py-4 ">
                        %
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_B")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pasivo.map((item, index) => (
                      <tr className={`border-b-2 `} key={index}>
                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                          {item?.created_date}
                        </th>
                        <td className="px-6 py-4 text-white">
                          {item?.message}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {formatNumber(item?.total_value || 0)} USD
                        </td>
                      </tr>
                    ))}
                    <tr className={`border-b-2 bg-gray-500 opacity-40"`}>
                      <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                      </th>

                      <td className="px-6 py-4 text-white">
                        {t("_DASHBOARD._TOTAL")}
                      </td>
                      <td className="px-6 py-4 text-white">
                        {formatNumber(totalArbitrage || 0)} USD
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/** Rango Infinito 4*/}
        {tabActive === "rango" && (
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full">
            <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                  <thead className="text-md text-white border-b-2">
                    <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_D")}
                      </th>
                      <th className="px-6 py-4 ">
                        -
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_B")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {range.map((item, index) => (
                      <tr className={`border-b-2 `} key={index}>
                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                          {item?.created_date}
                        </th>
                        <td className="px-6 py-4 text-white">
                          {item?.message}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {formatNumber(item?.total_value || 0)} USD
                        </td>
                      </tr>
                    ))}
                    <tr className={`border-b-2 bg-gray-500 opacity-40"`}>
                      <td className="px-6 py-4 text-white">
                      </td>
                      <td className="px-6 py-4 text-white">
                        {t("_DASHBOARD._TOTAL")}
                      </td>
                      <td className="px-6 py-4 text-white">
                        {formatNumber(totalRango || 0)} USD
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/** Binario 8*/}
        {tabActive === "binario" && (
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full">
            <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                  <thead className="text-md text-white border-b-2">
                    <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_D")}
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_STATISTICS._NUMBERSOPERATIONS")}
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_B")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {binary.map((item, index) => (
                      <tr className={`border-b-2 `} key={index}>
                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                          {item?.created_date}
                        </th>
                        <td className="px-6 py-4 text-white">
                          {item?.trx}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {formatNumber(item?.total_value || 0)} USD
                        </td>
                      </tr>
                    ))}
                    <tr className={`border-b-2 bg-gray-500 opacity-40"`}>

                      <td className="px-6 py-4 text-white">
                      </td>
                      <td className="px-6 py-4 text-white">
                        {t("_DASHBOARD._TOTAL")}
                      </td>
                      <td className="px-6 py-4 text-white">
                        {formatNumber(totalBinario || 0)} USD
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/** Binario Residual 9*/}
        {tabActive === "residual" && (
          <div div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full">
            <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                  <thead className="text-md text-white border-b-2">
                    <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_D")}
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_STATISTICS._NUMBERSOPERATIONS")}
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_B")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {residual.map((item, index) => (
                      <tr className={`border-b-2 `} key={index}>
                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                          {item?.created_date}
                        </th>
                        <td className="px-6 py-4 text-white">
                          {item?.trx}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {formatNumber(item?.total_value || 0)} USD
                        </td>
                      </tr>
                    ))}
                    <tr className={`border-b-2 bg-gray-500 opacity-40"`}>
                      <td className="px-6 py-4 text-white">
                      </td>
                      <td className="px-6 py-4 text-white">
                        {t("_DASHBOARD._TOTAL")}
                      </td>
                      <td className="px-6 py-4 text-white">
                        {formatNumber(totalResidual || 0)} USD
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/** Copy*/}
        {tabActive === "copy" && (
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full">
            <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                  <thead className="text-md text-white border-b-2">
                    <tr className="bg-black/60 text-blue-800 lg:text-1xl uppercase">
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_D")}
                      </th>
                      <th className="px-6 py-4 ">
                        -
                      </th>
                      <th className="px-6 py-4 ">
                        {t("_DASHBOARD._TABLE4_B")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {copy.map((item, index) => (
                      <tr className={`border-b-2 `} key={index}>
                        <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap text-white">
                          {item?.created_date}
                        </th>
                        <td className="px-6 py-4 text-white">
                          {item?.message}
                        </td>
                        <td className="px-6 py-4 text-white">
                          {formatNumber(item?.total_value || 0)} USD
                        </td>
                      </tr>
                    ))}
                    <tr className={`border-b-2 bg-gray-500 opacity-40"`}>
                      <td className="px-6 py-4 text-white">
                      </td>
                      <td className="px-6 py-4 text-white">
                        {t("_DASHBOARD._TOTAL")}
                      </td>
                      <td className="px-6 py-4 text-white">
                        {formatNumber(totalRango || 0)} USD
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  );
}
